import UINanoProgress from 'UIComponents/progress/UINanoProgress';
import { memo } from 'react';
import StyledUIFileAttachment from './StyledUIFileAttachment';
import { GYPSUM } from 'HubStyleTokens/colors';
import UITruncateString from 'UIComponents/text/UITruncateString';
import { jsx as _jsx } from "react/jsx-runtime";
const FileAttachmentWithProgress = ({
  fileName,
  progress
}) => {
  return /*#__PURE__*/_jsx(StyledUIFileAttachment, {
    fileName: /*#__PURE__*/_jsx(UITruncateString, {
      children: fileName
    }),
    size: "small",
    style: {
      backgroundColor: GYPSUM
    },
    "data-test-id": "file-attachment-with-progress",
    children: /*#__PURE__*/_jsx(UINanoProgress, {
      value: progress,
      boxShadow: false
    })
  });
};
export default /*#__PURE__*/memo(FileAttachmentWithProgress);